// extracted by mini-css-extract-plugin
module.exports = {"type_regular14":"Axis_type_regular14__ysRVl","root":"Axis_root__fsIgL"};